import { useState } from 'react'
import { FormattedMessage } from 'react-intl'
import ShareDialog from '@components/dialog/ShareDialog/ShareDialog'

import './ShareButton.css'

interface ShareButtonProps {
  title?: string
  text?: string
  url?: string
}

export default function ShareButton({ title, text, url }: ShareButtonProps) {
  const [isOpen, setIsOpen] = useState(false)

  return (
    <>
      <button className="button share-button" onClick={() => setIsOpen(true)}>
        <span className="icon icon-share" />
        <span className="text">
          <FormattedMessage id="share" />
        </span>
      </button>
      <ShareDialog
        isOpen={isOpen}
        onClose={() => setIsOpen(false)}
        title={title}
        text={text}
        url={url}
      />
    </>
  )
}
